import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { formatDateYYYYMM, IMonthValue } from '../util/DateUtils';
import { ISummaryReportData } from '../util/DataModelInterface';

export interface ReportRow {
  [key: string]: any
}

export const getSummaryReportData = async (reportingMonth: IMonthValue) => {
  const date = formatDateYYYYMM(reportingMonth);
  const url = `${getFunctionBaseUrl()}/api/CalculateSummaryReport/${date}`;
  const response = await rest.get(url);
  return response;
}

export const saveSummaryReportData = async (reportingMonth: IMonthValue,
                                            report: ISummaryReportData) => {
  const date = formatDateYYYYMM(reportingMonth);
  const url = `${getFunctionBaseUrl()}/api/CalculateSummaryReport/${date}`;
  const response = await rest.post(url, report);
  return response;
}

export const getCompareSummaryReport = async (type: string, startMonth: IMonthValue, endMonth: IMonthValue) => {
  const start = formatDateYYYYMM(startMonth);
  const end = formatDateYYYYMM(endMonth);
  const url = `${getFunctionBaseUrl()}/api/compareSortsummary/${type}/${start}/${end}`;
  const response = await rest.get(url);
  return response;
}

export const exportCompareSummaryReport = async (type: string, data: any) => {
  const url = `${getFunctionBaseUrl()}/api/exportReport/${type}`;
  const response = await rest.exporting(url, data);
  return response;
}